module.exports = __webpack_public_path__ + "static/machine_learning_classif-5b835b741d668c4d987400204cbbf13d.jpg";